import { render } from "./EmployerStudentsDrilldownModal.vue?vue&type=template&id=572c8234&scoped=true"
import script from "./EmployerStudentsDrilldownModal.vue?vue&type=script&lang=js"
export * from "./EmployerStudentsDrilldownModal.vue?vue&type=script&lang=js"

import "./EmployerStudentsDrilldownModal.vue?vue&type=style&index=0&id=572c8234&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-572c8234"

export default script